import { makeAutoObservable } from "mobx";
import { pagingPatientRank } from "app/services/PatientRank";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  getServiceRequestItemById,
  pagingServiceRequestItem,
} from "app/services/ServiceRequestItemService";
import {
  LAServiceRequestItemStatusEnum,
  SERVICE_REQUEST_STATUS,
  SERVICE_REQUEST_STATUS_NEW,
} from "app/common/LocalConst";
import { getCurrentStaff } from "app/common/LocalFunction";
import {
  cancelReceiveMultipleTreatments,
  getMultipleServiceRequestItemWithServiceSteps,
  getServiceRequestItemWithServiceSteps,
  saveMultipleServiceRequestItemWithSteps,
} from "app/services/ServiceRequestItemStepService";
import { undoMarkMultipleServiceAsCompletedByServiceRequestItem } from "app/services/DiagnosticReportService";

const defaultValue = {
  ...new SearchObject(),
  orderDateFrom: new Date(new Date().setHours(0, 0, 0, 0)), // Thời gian chỉ định từ
  orderDateTo: (() => new Date(new Date().setHours(23, 59, 59, 999)))(), // Thời gian chỉ định đến
};
export default class TreatmentListAllStore {
  searchTreatmentListAll = {
    ...defaultValue,
  };
  pageTreatmentListAll = new PageResponse();
  selectedRowTreatmentList = [];
  listCoordinate = [];
  listCoordinateCancel = [];
  listCoordinateUndoCompleted = [];
  openCancelPopupAssign = false;
  allocationServiceInfo = null;
  openUndoCompleteMultipleTreatmentPopup = false;
  openAssign = false;
  openConfirmMessage = null;
  permissionErrorMessage = null;

  handleCloseErrorMessage = () => {
    this.openConfirmMessage = null;
    this.permissionErrorMessage = null;
  };

  constructor() {
    makeAutoObservable(this);
  }

  pagingTreatmentListAll = async () => {
    const { departmentId, performerId, roomId, healthCareSvId, ...ortherData } =
      this.searchTreatmentListAll;

    // Không call API nếu không có cơ sở (bắt buộc)
    if (!departmentId) {
      this.pageTreatmentListAll = new PageResponse();
      return;
    }

    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }

    if (performerId) {
      ortherData.performerId = performerId?.id;
    }

    if (roomId) {
      ortherData.roomId = roomId?.id;
    }
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }
    return await pagingServiceRequestItem({ ...ortherData })
      .then(({ data }) => {
        this.pageTreatmentListAll = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hạng khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchTreatmentListAll) => {
    this.searchTreatmentListAll = {
      ...this.searchTreatmentListAll,
      ...searchTreatmentListAll,
    };
    this.pagingTreatmentListAll();
  };

  setSelectedRowTreatmentList = (row) => {
    this.selectedRowTreatmentList = row;
  };

  handelOpenAssign = async (state) => {
    //chỉ lọc ra loại là mới chỉ định
    try {
      let chosenIds = this.selectedRowTreatmentList
        ?.filter(
          (el) => el?.itemStatus === LAServiceRequestItemStatusEnum.NEW.value,
        )
        ?.map((el) => el?.id);
      const { data } =
        await getMultipleServiceRequestItemWithServiceSteps(chosenIds);
      const staff = getCurrentStaff();
      const encounterParticipants = staff
        ? [
            {
              position: staff?.position,
              staff,
            },
          ]
        : [];
      let formatData =
        data?.length > 0 &&
        data?.map((el) => ({
          ...el,
          performer: el?.performer ? el?.performer : staff,
          encounterParticipants: el?.encounterParticipants
            ? el?.encounterParticipants
            : encounterParticipants,
        }));
      this.listCoordinate = [...formatData];

      this.openAssign = state;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  handelCloseAssign = () => {
    this.openAssign = false;
    this.listCoordinate = [];
  };

  handleOpenReceiveTreatment = async (treatment) => {
    try {
      const { data } = await getServiceRequestItemWithServiceSteps(
        treatment?.id,
      );

      const staff = getCurrentStaff();
      const encounterParticipants = staff
        ? [
            {
              position: staff?.position,
              staff,
            },
          ]
        : [];
      this.listCoordinate = [
        {
          ...data,
          performer: data?.performer ? data?.performer : getCurrentStaff(),
          encounterParticipants: data?.encounterParticipants
            ? data?.encounterParticipants
            : encounterParticipants,
        },
      ];

      this.openAssign = true;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  handleSaveServiceSteps = async (Steps) => {
    try {
      const { data } = await saveMultipleServiceRequestItemWithSteps(Steps);
      if (
        data &&
        Array.isArray(data) &&
        data.some((item) => item.responseStatus === false)
      ) {
        const errorItem = data.find((item) => item.responseStatus === false);
        setTimeout(() => {
          if (errorItem.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = errorItem.responseDetail;
          } else {
            this.openConfirmMessage = errorItem.responseDetail || "Tiếp nhận điều trị thất bại!";
          }
        }, 500);
        return;
      }
      toast.success("Tiếp nhận điều trị thành công!");
      this.handelCloseAssign();
      this.pagingTreatmentListAll();
    } catch (error) {
      toast.error("Tiếp nhận điều trị thất bại!");
      console.error("Tiếp nhận điều trị thất bại!:", error);
    }
  };

  handleOpenAllocationServicePopup = async (serviceRequestItemId) => {
    try {
      const { data } = await getServiceRequestItemById(serviceRequestItemId);
      this.allocationServiceInfo = {
        ...data,
      };
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu chỉ định");
    }
  };
  handleCloseAllocationServicePopup = async () => {
    this.allocationServiceInfo = null;
  };

  handlePopupCancelTreatmentAll = async (row) => {
    //chỉ lọc ra loại là đã điều phối

    try {
      let chosenIds = this.selectedRowTreatmentList
        ?.filter(
          (el) =>
            el?.itemStatus === LAServiceRequestItemStatusEnum.RECEIVED.value,
        )
        ?.map((el) => el?.id);

      const { data } =
        await getMultipleServiceRequestItemWithServiceSteps(chosenIds);
      this.listCoordinateCancel = data;
      this.openCancelPopupAssign = true;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  handlePopupCancelTreatment = async (row) => {
    try {
      let chosenIds = [row?.id];

      const { data } =
        await getMultipleServiceRequestItemWithServiceSteps(chosenIds);
      this.listCoordinateCancel = data;
      this.openCancelPopupAssign = true;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };
  handleCancelServiceAll = async (ids) => {
    try {
      const { data } = await cancelReceiveMultipleTreatments(ids);
      if (
        data &&
        Array.isArray(data) &&
        data.some((item) => item.responseStatus === false)
      ) {
        const errorItem = data.find((item) => item.responseStatus === false);
        setTimeout(() => {
          if (errorItem.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = errorItem.responseDetail;
          } else {
            this.openConfirmMessage = errorItem.responseDetail || "Hủy thất bại!";
          }
        }, 500);
        return;
      }
      toast.success("Hủy thành công!");
      this.handleClosePopupCancelTreatment();
      this.pagingTreatmentListAll();
    } catch (error) {
      toast.error("Hủy thất bại!");
      console.error("Hủy thất bại!:", error);
    }
  };

  handleClosePopupCancelTreatment = () => {
    this.openCancelPopupAssign = false;
    this.listCoordinateCancel = [];
  };

  handleOpenUndoCompleteMultipleTreatmentPopup = () => {
    this.listCoordinateUndoCompleted = this.selectedRowTreatmentList?.filter(
      (el) => el?.itemStatus !== LAServiceRequestItemStatusEnum.RECEIVED.value,
    );
    this.openUndoCompleteMultipleTreatmentPopup = true;
  };

  handleOpenUndoCompleteSingleTreatmentPopup = (row) => {
    this.listCoordinateUndoCompleted = [row];
    this.openUndoCompleteMultipleTreatmentPopup = true;
  };

  handleCloseUndoCompleteMultipleTreatmentPopup = () => {
    this.openUndoCompleteMultipleTreatmentPopup = false;
  };

  handleConfirmUndoCompleteMultipleTreatment = async () => {
    try {
      let chosenIds = this.selectedRowTreatmentList
        ?.filter(
          (el) =>
            el?.itemStatus === LAServiceRequestItemStatusEnum.FINISHED.value,
        )
        ?.map((el) => el?.id);

      const { data } =
        await undoMarkMultipleServiceAsCompletedByServiceRequestItem(chosenIds);

      if (
        data &&
        Array.isArray(data) &&
        data.some((item) => item.responseStatus === false)
      ) {
        const errorItem = data.find((item) => item.responseStatus === false);
        setTimeout(() => {
          if (errorItem.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = errorItem.responseDetail;
          } else {
            this.openConfirmMessage = errorItem.responseDetail || "Hủy đánh dấu hoàn thành điều trị thất bại!";
          }
        }, 500);
        return data;
      }

      this.handleCloseUndoCompleteMultipleTreatmentPopup();
      this.pagingTreatmentListAll();

      toast.success("Đã hủy hoàn thành điều trị");

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Hủy đánh dấu hoàn thành điều trị có lỗi");
    }
  };
  resetStore = () => {
    this.searchTreatmentListAll = { ...defaultValue };
    this.pageTreatmentListAll = new PageResponse();
    this.selectedRowTreatmentList = [];
  };
}
